import { refreshReducersToInitial } from "./refreshData-action";

export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS" as const;

export type UserDetails = {
  firstName: string;
  lastName: string;
  stateCode: string;
  zip: string;
}

export const updateUserDetails = (payload: UserDetails) => ({ type: UPDATE_USER_DETAILS, payload } as const);

export type UserDetailsActions =
  | ReturnType<typeof updateUserDetails>
  | ReturnType<typeof refreshReducersToInitial>;